((myDoc)=>{

    const limit = 10;
    var start = 20;
    var reachMax = false;
    var docHeight = 0;
    var sort = '';
    var borough = [];
    var price = [];
    var nationality = [];
    var hair_colour = [];
    var services = [];
    var location = '';
    var category = '';
    let filterInput =  myDoc.querySelectorAll('.filter-list input');
    const galleryRow = myDoc.querySelector('.gallery-row');
    const counter = myDoc.querySelector('.counter');
    const serviceDiv = myDoc.querySelector('div.service');
    const locationDiv = myDoc.querySelector('div.location');
    const categoryDiv = myDoc.querySelector('div.category');
    const clearFilter = myDoc.querySelector('.clear_filter');
    const filterCls = myDoc.querySelector('.filter-close');
    const showModel = myDoc.querySelector('.filter-btns span');

    if (galleryRow) { // Check if the element exists
        window.addEventListener('scroll', () => { // Use addEventListener
            let less = 2200;
            if (galleryRow.scrollHeight <= 2200) {
                less = 0;
            }
            if (window.scrollY > galleryRow.scrollHeight - less) { // Use window.scrollY
                if (docHeight < 1) {
                    docHeight = 1;
                    getStaff();
                }
            }
        });
    }

    function getStaff() {
        // const loader = document.querySelector(".showLoader"); // Select loader
        // if (loader) {
        //     loader.classList.remove('d-none'); // Remove loader
        // }

        if(locationDiv){
            location = locationDiv.innerHTML;
        }

        if(serviceDiv && !services.includes(serviceDiv.innerHTML)) {
            services.push(serviceDiv.innerHTML);
        }

        if(categoryDiv){
            category = categoryDiv.innerHTML;
        }

        if (reachMax) {
            return false;
        } else {
            fetch(filterUrl, { // Use fetch API
                method: 'POST',
                headers: {
                'Content-Type': 'application/x-www-form-urlencoded', // Important for POST data
                'X-CSRF-TOKEN': csrfToken // Add CSRF token if needed
                },
                body: new URLSearchParams({ // Use URLSearchParams for form data
                    limit: limit,
                    skip: start,
                    sort: sort,
                    borough: borough,
                    prices: price,
                    nationality: nationality,
                    hair_colour: hair_colour,
                    services: services,
                    location: location,
                    category: category,
                }),
            })
            .then(response => response.json()) // Parse JSON response
            .then(list => {
                //console.log(list);

                // if (loader) {
                //     loader.classList.add('d-none'); // Remove loader
                // }


                if (list && list.html) { //Check if list and list.html exists
                    //console.log(galleryRow);
                    galleryRow.insertAdjacentHTML('beforeend', list.html); // Use insertAdjacentHTML
                    if (window.applyGalleryViewMode) {
                        window.applyGalleryViewMode(galleryRow);
                    }
                    counter.innerHTML = list.count;
                    start += limit;
                    docHeight = 0;
                    if(!showModel.classList.contains('show-model')) {
                        showModel.classList.add('show-model');
                    }
                } else {
                    if (start < 1) {
                        galleryRow.innerHTML = `
                            <div class="col-lg-12">
                            <div class="alert alert-warning" role="alert">
                                No Models Found!
                            </div>
                            </div>
                        `;
                        counter.innerHTML = 0;
                        if(showModel.classList.contains('show-model')) {
                            showModel.classList.remove('show-model');
                        }
                    }
                    console.log(list);
                    reachMax = true;
                    return false;
                }
            })
            .catch(error => {
                console.error("Error fetching data:", error); // Handle errors
            });
        }
    }

    const getArrayInputValues = (inputName) => {
        const inputElements = myDoc.querySelectorAll(`input[name="${inputName}"]`);
        let filterval = [];
        inputElements.forEach(input => {
            if (input.checked) {
                if (!filterval.includes(input.value)) {
                    filterval.push(input.value);
                }
            } else {
                filterval = filterval.filter(value => value !== input.value);
            }
        });
        //console.log(filterval);
        return filterval;
    }

    filterInput.forEach(item=>{
        item.addEventListener('input', (e)=>{
            let inputName = e.target.name;
            if(e.target.classList.contains('price')){
                //console.log(e.target);
                price = getArrayInputValues(inputName);
                //console.log(price);
            }
            if(e.target.classList.contains('nationality')){
                //console.log(e.target);
                nationality = getArrayInputValues(inputName);
                //console.log(nationality);
            }
            if(e.target.classList.contains('hair_color')){
                //console.log(e.target);
                hair_colour = getArrayInputValues(inputName);
                //console.log(hair_colour);
            }
            if(e.target.classList.contains('service')){
                //console.log(e.target);
                services = getArrayInputValues(inputName);
                //console.log(services);
            }

            // console.log({
            //     price,
            //     nationality,
            //     hair_colour,
            //     services
            // });
            clearFilter.classList.remove('d-none');
            galleryRow.innerHTML = ``;
            start = 0;
            reachMax = false;
            docHeight = 0;
            getStaff();
        })
    });

    const addRemoveActiveOnclick = (ele) => {
        if(ele) {
            let targetEle = myDoc.querySelector(ele),
            actinArray = targetEle.querySelectorAll('li'),
            clearBorough = targetEle.querySelector('.btn-clearBorough');
            let hasActive = false;
            //let clearBorough = myDoc.querySelector(ele);
            actinArray.forEach(i => {
                i.addEventListener('click', (e)=> {
                    e.target.classList.toggle('active');
                    if(e.target.classList.contains('active')){
                        borough.push(i.dataset.slug);
                    }else{
                        borough = borough.filter(s => s !== i.dataset.slug);
                    }
                    galleryRow.innerHTML = ``;
                    start = 0;
                    reachMax = false;
                    docHeight = 0;
                    //console.log(borough)
                    getStaff();

                    hasActive = Array.from(actinArray).some(item => item.classList.contains('active'));
                    //console.log(hasActive);
                    hasActive?clearBorough.classList.remove('d-none'):clearBorough.classList.add('d-none');

                })
            })

            clearBorough.addEventListener('click', (e) => {
                actinArray.forEach(item => {
                    item.classList.contains('active')?item.classList.remove('active'):null;
                });
                setTimeout(()=>{e.target.classList.add('d-none')}, 100)
                galleryRow.innerHTML = ``;
                start = 0;
                reachMax = false;
                docHeight = 0;
                borough = [];
                //console.log(borough)
                getStaff();
            })
        }
    }
    //addRemoveActiveOnclick('.dropdown-borough')

    clearFilter.addEventListener('click', () => {
        const checkInput = myDoc.querySelectorAll(`input[type="checkbox"]`);
        //const sortList = '';
        galleryRow.innerHTML = '';
        checkInput.forEach(input => {
            if (input.checked) {
                input.checked = false;
            }
        });

        const recommendedOption = myDoc.querySelector(`input[data-name="desk-sortby"][value=""]`);
        if (recommendedOption) {
            recommendedOption.checked = true;
        }

        const recommendedMobileOption = myDoc.querySelector(`input[data-name="mobile-sortby"][value=""]`);
        if (recommendedMobileOption) {
            recommendedMobileOption.checked = true;
        }


        const sortDropdown = myDoc.querySelector('.dropdown-sortby .btn span');
        if (sortDropdown) {
            sortDropdown.innerHTML = recommendedOption ? recommendedOption.dataset.value : "Recommended";
        }

        clearFilter.classList.add('d-none');

        sort = '';
        price = [];
        nationality = [];
        hair_colour = [];
        services = [];
        location = '';
        category = '';
        reachMax = false;
        start = 0;
        getStaff();
    });

    const syncSort = (sourceName, targetName) => {
        myDoc.addEventListener('change', function(e) {
            if (e.target.matches(`input[data-name="${sourceName}"]`)) {
                //alert('e.target');
                //console.log(e.target, e.isTrusted);
                if (e.isTrusted) {
                    const targetRadios = myDoc.querySelectorAll(`input[data-name="${targetName}"]`);
                    let alreadySynced = false;
                    //console.log(targetRadios);
                    targetRadios.forEach((targetRadio) => {
                        if (targetRadio.value === e.target.value && !targetRadio.checked) {
                            targetRadio.checked = true;
                            const event = new Event('change');
                            event.isTrusted = false; //Returns true if event was dispatched by the user agent, and false otherwise.
                            targetRadio.dispatchEvent(event);
                            alreadySynced = true;
                        }
                    });


                    //console.log(e.target);

                    if (alreadySynced) {
                        myDoc.querySelector('.dropdown-sortby .btn span').innerHTML = e.target.dataset.value;
                        sort = e.target.value;
                        galleryRow.innerHTML = ``;
                        start = 0;
                        reachMax = false;
                        docHeight = 0;
                        getStaff();
                        clearFilter.classList.remove('d-none');
                    }
                }
            }
        });
    }

    showModel.addEventListener('click', () => {
        if(showModel.classList.contains('show-model')){
            filterCls.click();
        }
    });

    syncSort('desk-sortby', 'mobile-sortby');
    syncSort('mobile-sortby', 'desk-sortby');



})(document);
